import HubspotForm from "react-hubspot-form";

function HealthyNewYear() {
    return (
        <div className="hl-nw-yr-parent">
            <section className="position-relative pb-5 feat_box vfitsoln sc-2 hmpg hl-new-yr-hero">
                <div className="px-3 px-md-5 py-5  feat_pb0 mb-0">
                    <div className="d-flex m-d-block justify-content-between align-items-center container custom_container p0">
                        <div className="col-12 col-md-5 p-0">
                            <div className="col-12 p-0">
                                <h2 className="font-weight-bold py-2 section-heading">
                                    By the HRs, <br />
                                    For the{" "}
                                    <span className="text-green">
                                        Employees
                                    </span>{" "}
                                </h2>

                                <h2 className="font-weight-bold text-center text-md-left py-4 text-light mb-0">
                                    Maximize your Employee Wellness Efforts this
                                    New Year
                                </h2>
                                <h4 className="text-light font-weight-normal py-0">
                                    {" "}
                                    Start 2024 on a Healthier Note. <br /> Help
                                    your Employees Reach their Wellness Goals
                                    with Vantage Fit
                                </h4>
                            </div>
                        </div>
                        <div className="w-100 d-flex  justify-content-center my-4 hl-nw-caapm-frmsec">
                            <div className="col-12 col-md-7 pl-3 pr-2 pl-md-4 pr-md-3 py-4 form-bord">
                                <div>
                                    <div className="text-center" id="form">
                                        <h4 className="text-center text-light pr-2">
                                            Start your journey towards fostering
                                            a dynamic culture of appreciation
                                        </h4>
                                        <div>
                                            <HubspotForm
                                                portalId="6153052"
                                                formId="517ebc0a-e3b2-48e7-994d-19507b711e00"
                                                onSubmit={() =>
                                                    console.log("Submit!")
                                                }
                                                onReady={(form) =>
                                                    console.log("Form ready!")
                                                }
                                                loading={<div>Loading...</div>}
                                            />
                                        </div>
                                        <p
                                            className="text-light"
                                            style={{
                                                textDecoration: "underline",
                                                fontSize: "12px",
                                            }}
                                        >
                                            We safeguard your{" "}
                                            <a
                                                href="https://www.vantagecircle.com/privacy-policy/"
                                                className="text-orange"
                                            >
                                                Privacy
                                            </a>
                                        </p>
                                        <script
                                            charset="utf-8"
                                            type="text/javascript"
                                            src="//js.hsforms.net/forms/embed/v2.js"
                                        ></script>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="position-relative pb-5 feat_box vfitsoln sc-2 hmpg hlnwyr hl-nw-yr-hlth-res pt-5">
                <div className="col-12 text-center">
                    <div className="col-12 p-0">
                        <h2 className="font-weight-bold py-2 section-heading mb-4">
                            Don't Let your Employees Miss Out on Their <br />
                            <span className="text-green  ft-charmonman">
                                <img
                                    src="https://res.cloudinary.com/vantagecircle/image/upload/q_auto/gatsbycms/uploads/2023/11/New-year.png"
                                    alt=""
                                />
                            </span>{" "}
                            Health Resolutions
                        </h2>
                        <h4 className="text-light font-weight-light">
                            Here's How We Can Help
                        </h4>
                    </div>
                </div>
                <div className="px-3 px-md-5  mb-0">
                    <div className="d-flex m-d-block justify-content-between align-items-center container custom_container p0">
                        <div className="col-12 col-md-6 p-0">
                            <div className="col-12 p-0">
                                <ul className="text-light p-0 nw-yr-res-ul">
                                    <li className="nw-yr-res-li">
                                        Specially Curated Corporate New Year
                                        Wellness Challenges.
                                    </li>
                                    <li className="nw-yr-res-li">
                                        Get a Complete Overview of Your Wellness
                                        Campaign with Intuitive Dashboard.
                                    </li>
                                    <li className="nw-yr-res-li">
                                        Encourage Sportsmanship Amongst
                                        Employees with a Live Leaderboard.
                                    </li>
                                    <li className="nw-yr-res-li">
                                        Multiply Employee Participation Cutting
                                        Across Geographies with our Al-Powered
                                        Application.
                                    </li>
                                    <li className="nw-yr-res-li">
                                        Dedicated Support Team to Keep Your
                                        Wellness Campaign on Track.
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="cta-img w-100">
                            <div className="d-flex justify-content-center">
                                <img
                                    loading="lazy"
                                    src="https://res.cloudinary.com/vantagecircle/image/upload/q_auto/gatsbycms/uploads/2023/11/phone.png"
                                    alt="Struggling to keep your employees active during work hours?"
                                    style={{ height: "600px" }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="position-relative pb-5 bg-light vfitsoln sc-2 hl-nw-yr-hlth-text  pt-5 ">
                <div className="col-12 text-center">
                    <div className="col-12 p-0">
                        <h1 className="font-weight-bold section-heading py-2 mb-4">
                            Why You Should Focus On Employee Wellness in 2024
                        </h1>
                    </div>
                </div>
            </section>
            <section className="position-relative pb-5 vfitsoln sc-2 hmpg pt-5 px-5 hl-nw-yr-imp">
                <div className="col-12 container custom_container">
                    <div className="row">
                        <div className="col-12 p-0 col-md-4 mb-3">
                            <div className=" focus-sect impt-1">
                                <p className="focusstat purplefont mb-4 text-bold font-weight-bold">
                                    20%
                                </p>
                                <p className="mb-5">
                                    reduction in <br /> employee attrition
                                </p>
                                <p className="section-para mb-0">
                                    Gallup's research indicates that employees
                                    who feel their well- being is supported by
                                    their organization are 20% more likely to
                                    stay with the company.
                                </p>
                            </div>
                        </div>
                        <div className="col-12 col-md-4 mb-3">
                            <div className=" focus-sect impt-2">
                                <p className="focusstat greenfont mb-4 font-weight-bold">
                                    81%
                                </p>
                                <p className="mb-5">
                                    Increase in <br /> Employer Branding
                                </p>
                                <p className="section-para mb-0">
                                    A study by Quantum Workplace found that 81%
                                    of employees who participated in wellness
                                    programs had a positive view of their
                                    employer.
                                </p>
                            </div>
                        </div>
                        <div className="col-12 col-md-4 mb-3">
                            <div className=" focus-sect impt-3">
                                <p className="focusstat redfont mb-4 font-weight-bold">
                                    25%
                                </p>
                                <p className="mb-5">
                                    More Savings on <br />
                                    Healthcare and Other Cost
                                </p>
                                <p className="section-para mb-0">
                                    A systematic review of 56 published studies
                                    of worksite health programs showed that
                                    well-implemented workplace health programs
                                    can lead to 25% savings each on absenteeism,
                                    health care costs, and workers'
                                    compensation.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-5 line-impt mx-auto"></div>
            </section>
            <section className="vfit-loc impct-globe">
                <div className="container custom_container">
                    <div className="row d-flex justify-content-start align-items-center">
                        <div className="col-12">
                            <h2 className="font-weight-bold text-light text-center section-heading">
                                Impact of Vantage Fit on clients across the
                                globe.
                            </h2>
                        </div>
                        <div className="col-12 clientstat py-5">
                            <div className="col-12 p-0">
                                <div className="row row-impct-gap d-flex justify-content-between">
                                    <div className="d-flex p-0 col-6 col-md-2 ">
                                        <div className="statimg">
                                            <img src="https://res.cloudinary.com/vantagecircle/image/upload/w_40/v1680604657/VantageFit/2023/vfit-homapage-calories_burned-icon.png" />
                                        </div>
                                        <div className="focusstat">
                                            <div className="yellowfont font-weight-bold">
                                                1.2B+
                                            </div>
                                            <div className="smlfont">
                                                Calories burned
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex p-0 col-6 col-md-2 ">
                                        <div className="statimg">
                                            <img src="https://res.cloudinary.com/vantagecircle/image/upload/w_40/v1680604657/VantageFit/2023/vfit-homapage-steps-taken-icon.png" />
                                        </div>
                                        <div className="focusstat">
                                            <div className="greenfont font-weight-bold">
                                                19.4B
                                            </div>
                                            <div className="smlfont">
                                                Steps taken
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex p-0 col-6 col-md-2 ">
                                        <div className="statimg">
                                            <img src="https://res.cloudinary.com/vantagecircle/image/upload/w_40/v1680604657/VantageFit/2023/vfit-homapage-burger-icon.png" />
                                        </div>
                                        <div className="focusstat">
                                            <div className="yellowfont font-weight-bold">
                                                21M
                                            </div>
                                            <div className="smlfont">
                                                Big macs burned
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex p-0 col-6 col-md-2">
                                        <div className="statimg">
                                            <img src="https://res.cloudinary.com/vantagecircle/image/upload/w_40/v1680604657/VantageFit/2023/vfit-homapage-globe-icon.png" />
                                        </div>
                                        <div className="focusstat">
                                            <div className="greenfont font-weight-bold">
                                                345x
                                            </div>
                                            <div className="smlfont">
                                                Around the globe
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="position-relative bg-light-yellow">
                <div className="container custom_container p0 d-flex m-d-block">
                    <div className="col-12 text-center bottom-cta-section">
                        <h2 className="font-weight-bold py-2 hero-heading">
                            Empower your team with well-being.
                        </h2>
                        <p>
                            Let's make 2024 the year of employee wellness. Take
                            the first step - transform your workplace.
                        </p>
                        <div className="mtb25 d-flex justify-content-center">
                            <a href="#form" className="vfitcompanycta cta_b">
                                Talk to our experts
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default HealthyNewYear;
